import React, { Component } from 'react';
import { Elements, StripeProvider } from 'react-stripe-elements';
import PurchaseForm from './PurchaseForm';
import stripe_api from '../../api/stripe';
import { Subnav } from '../subnav';
import queryString from 'query-string'
// export const PurchasePage = () => {
class PurchasePage extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {}
        // this.handleUpdate = this.handleUpdate.bind(this);
    }
    componentDidMount() {
        const values = queryString.parse(this.props.location.search);
        this.setState({ qvals: values });
    }
    // handleUpdate(value) {
    //     this.setState(value);
    // }
    render() {
        return (
            <main className="page">
                <div className="page__subnav">
                    <Subnav isPayer={false} />
                </div>
                <div className="mainpage">
                    <div className="mainpage__content">
                        <div className="PurchasePage">
                            <h2>Order Form</h2>
                            <div className="PurchasePage__form">
                                <StripeProvider apiKey={stripe_api.API_KEY}>
                                    <Elements>
                                        <PurchaseForm vals={this.state.qvals} />
                                    </Elements>
                                </StripeProvider>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        );
    }
};
export default PurchasePage;


// WEBPACK FOOTER //
// ./src/components/purchase/PurchasePage.js